var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97786 18.9557C5.0362 18.9557 1.01953 14.9391 1.01953 9.99739C1.01953 5.05573 5.0362 1.03906 9.97786 1.03906C14.9195 1.03906 18.9362 5.05573 18.9362 9.99739C18.9362 14.9391 14.9195 18.9557 9.97786 18.9557ZM9.97786 2.28906C5.72786 2.28906 2.26953 5.7474 2.26953 9.99739C2.26953 14.2474 5.72786 17.7057 9.97786 17.7057C14.2279 17.7057 17.6862 14.2474 17.6862 9.99739C17.6862 5.7474 14.2279 2.28906 9.97786 2.28906Z",
    fill: "#FF6551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0987 13.2745C12.9904 13.2745 12.882 13.2495 12.782 13.1828L10.1987 11.6411C9.55703 11.2578 9.08203 10.4161 9.08203 9.67448V6.25781C9.08203 5.91615 9.36536 5.63281 9.70703 5.63281C10.0487 5.63281 10.332 5.91615 10.332 6.25781V9.67448C10.332 9.97448 10.582 10.4161 10.8404 10.5661L13.4237 12.1078C13.7237 12.2828 13.8154 12.6661 13.6404 12.9661C13.5154 13.1661 13.307 13.2745 13.0987 13.2745Z",
    fill: "#FF6551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessage);
export default __webpack_public_path__ + "static/media/error-message.65af34a28a8254f7f955e4079e0b3d55.svg";
export { ForwardRef as ReactComponent };